import { render, staticRenderFns } from "./SelectorMatchDelay.vue?vue&type=template&id=00061c04&scoped=true&lang=pug&"
import script from "./SelectorMatchDelay.vue?vue&type=script&lang=js&"
export * from "./SelectorMatchDelay.vue?vue&type=script&lang=js&"
import style0 from "./SelectorMatchDelay.vue?vue&type=style&index=0&id=00061c04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00061c04",
  null
  
)

export default component.exports